
import { colorsSuggested } from "@/helpers/suggestedColors";
import { defineComponent } from "vue";
import LUserLink from "../LUserLink/LUserLink.vue";
import LTagColor from "./LTagColor.vue";

export default defineComponent({
  data() {
    return {
      recomendedColorValue: "",
      suggestedList: colorsSuggested(),
    };
  },
  props: ["name", "selectedColor"],
  methods: {
    handleSetColor(color: string) {
      this.$emit("update:color", color);
    },
    inputColor(e: Event) {
      this.$emit("update:color", (e.target as HTMLInputElement).value);
    },
  },
  components: { LTagColor, LUserLink },
});
